import React from 'react';
import PropTypes from 'prop-types';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

import LeadsCard from './leads';
import ActivityCard from './activity';
import WebsiteCard from './website';
import EmailCard from './email';
import CustomCard from './custom';
import SyndicationCard from './syndication';

class PreviewCard extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    card: PropTypes.object,
    setActiveCard: PropTypes.func
  }

  clientView = () => !this.props.addCard

  renderCard = () => {
    const {
      card,
      fetchingLeads,
      leads,
      metrics,
      addCard,
      leadStatuses,
      connectDragSource,
      connectDragPreview,
      setActiveCard,
      isDragging
    } = this.props;

    const baseProps = {
      card,
      connectDragSource,
      connectDragPreview,
      draggable: !this.clientView(),
      fullScreen: false,
      isDragging,
      key: card.id,
      name: `${card.cardType}ReportPanel`,
      onSetAsActive: setActiveCard,
      onVisibilityChanged: this.clientView() ? null : this.props.onUpdateCardVisibility
    };

    switch (card.cardType) {
    case 'activity':
      return <ActivityCard {...baseProps} metadata={metrics.activityMetadata} />;
    case 'custom': {
      let saveFunc = null;

      if (!this.clientView()) {
        saveFunc = addCard;
      }

      return <CustomCard {...baseProps} readOnly={this.clientView()} onSave={saveFunc} />;
    }
    case 'email':
      return <EmailCard {...baseProps} {...metrics} />;
    case 'leads':
      return (
        <LeadsCard
          {...baseProps}
          editable={!this.clientView()}
          leads={leads}
          leadStatuses={leadStatuses}
          loading={fetchingLeads}
          onUpdateNote={this.props.updateLeadNote}
        />
      );
    case 'website':
      return <WebsiteCard {...baseProps} metrics={metrics} />;
    case 'syndication':
      return <SyndicationCard {...baseProps} syndicationPartners={metrics.syndicationPartners} />;
    }
  }

  render() {
    const style = {
      opacity: this.props.isDragging ? 0 : 1
    };

    return this.props.connectDropTarget(
      <div className="draggable-wrapper" style={style}>
        {this.renderCard()}
      </div>
    );
  }
}

export default reorderableListItem(PreviewCard, 'reportPreview', {
  beginDrag(props) {
    props.onBeginDrag();

    return {
      id: props.card.id,
      index: props.index
    };
  },
  endDrag(props, monitor) {
    props.onEndDrag(props, monitor);
  }
});
